import { render, staticRenderFns } from "./Sczp.vue?vue&type=template&id=41617c81&scoped=true"
import script from "./Sczp.vue?vue&type=script&lang=js"
export * from "./Sczp.vue?vue&type=script&lang=js"
import style0 from "./Sczp.vue?vue&type=style&index=0&id=41617c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41617c81",
  null
  
)

export default component.exports